// Helpers de texto usados por todos os templates. Sempre escapar entrada do
// usuário antes de interpolar em HTML — este HTML vai ser colado de verdade
// no site da Lorena, então nunca é seguro confiar no conteúdo cru.

export function escapeHtml(input: string): string {
  return input
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

/**
 * Converte uma convenção simples tipo markdown (**negrito**) em <b>,
 * escapando o restante do texto. Usado nos campos de "dek"/legenda que têm
 * um trecho em destaque (ver DOCS/01-capa.md — <b>futuro da tecnologia</b>).
 */
export function formatWithBold(input: string): string {
  const parts = input.split(/(\*\*[^*]+\*\*)/g)
  return parts
    .map((part) => {
      const match = part.match(/^\*\*([^*]+)\*\*$/)
      if (match) return `<b>${escapeHtml(match[1])}</b>`
      return escapeHtml(part)
    })
    .join('')
}

/** Igual ao `formatWithBold`, mas preservando quebras manuais de linha. */
export function formatWithBoldLines(input: string): string {
  return formatWithBold(input).replace(/\n/g, '<br>')
}

/** Quebra um texto em parágrafos (uma linha em branco = novo parágrafo). */
export function toParagraphs(input: string): string[] {
  return input
    .split(/\n{2,}/)
    .map((p) => p.trim())
    .filter(Boolean)
}

/** Cada linha do textarea vira uma quebra manual (<br>) — escapando o texto. */
export function toBrLines(input: string): string {
  return input
    .split(/\n/)
    .map((line) => escapeHtml(line.trim()))
    .join('<br>')
}

/** Uma única linha "corrida" — junta quebras de linha em espaço (parágrafo fluido). */
export function toFlowText(input: string): string {
  return escapeHtml(input.replace(/\s+/g, ' ').trim())
}
